import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import axios from "axios";
import { VAVE, APPROVEIL4DATA, APPROVEIL4QUALITYDATA } from "../../../Pages/AppConstant";
import { sourcingEmpIds } from "../switch_on_userlist";

function AlertDialogForm({ request, setRefreshApi }) {
  const [drawingValue, setDrawingValue] = useState("");
  const [ednValue, setEdnValue] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  
  const [implementedDate, setImplementedDate] = useState("");
  const [implementedVehicle, setImplementedVehicle] = useState("");
 const [inputValue, setInputValue] = useState("");
  

  const handleCloseAlert = () => setOpenAlert(false);

  const currentEmpId = localStorage.getItem("empid");

  const handleSubmit = async (status) => {
    // Validate first
// if(currentEmpId ===)

//     if (drawingValue.trim() === "" && ednValue.trim() === "") {
//       setOpenAlert(true);
//       return;
//     }
    setRefreshApi(true);
    const formData = new FormData();
    const currentEmpName = localStorage.getItem("empname");
//// production


      const url = currentEmpId === "300158"
        ? APPROVEIL4QUALITYDATA
        : APPROVEIL4DATA;
    if (currentEmpId === "300158") {
      formData.append("vin_no", implementedVehicle);
      formData.append("implementation_date", implementedDate);
      formData.append("approved_by_quality", currentEmpName);
      formData.append("quality_comment", inputValue);
      formData.append("quality_status", status);
    } else if (currentEmpId === "300321") {
      formData.append("ecn_edin", ednValue);
      formData.append("drawing_no", drawingValue);
      formData.append("approved_by_pd", currentEmpName);
      formData.append("pd_comment", inputValue);
      formData.append("pd_status", status);
    }

/////dev
    //   const url = currentEmpId === "300381"
    //     ? APPROVEIL4QUALITYDATA
    //     : APPROVEIL4DATA;

    //     if (currentEmpId === "300381") {
    //   formData.append("vin_no", implementedVehicle);
    //   formData.append("implementation_date", implementedDate);
    //   formData.append("approved_by_quality", currentEmpName);
    //         formData.append("quality_comment", inputValue);
    //   formData.append("quality_status", status);
    // } else if (currentEmpId === "EL_0003") {
    //   formData.append("ecn_edin", ednValue);
    //   formData.append("drawing_no", drawingValue);
    //   formData.append("approved_by_pd", currentEmpName);
    //         formData.append("pd_comment", inputValue);
    //   formData.append("pd_status", status);
    // }
    formData.append("idea_id", request?.id_x ?? "");



    try {
      setIsLoading(true);

      await axios.post(VAVE + url, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Submitted successfully!");
      setEdnValue("");
      setDrawingValue("");

      setRefreshApi(true);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setOpenAlert(false);
      setRefreshApi(true);

      setIsLoading(false);
    }
  };

//   return (

    
//     <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
//       <label htmlFor="comment" style={{ display: "block", marginBottom: 8 }}>
//         Drawing New/ Revision No*
//       </label>

//       <TextField
//         id="comment"
//         placeholder="Enter comment"
//         fullWidth
//         required
//         value={drawingValue}
//         onChange={(e) => setDrawingValue(e.target.value)}
//         size="small"
//       />
//       <label htmlFor="comment" style={{ display: "block", marginBottom: 8 }}>
//         ECN EDIN No*
//       </label>

//       <TextField
//         id="comment"
//         placeholder="Enter comment"
//         fullWidth
//         required
//         value={ednValue}
//         onChange={(e) => setEdnValue(e.target.value)}
//         size="small"
//       />

//       <div style={{ marginTop: "20px", textAlign: "right" }}>
//         <Button
//           variant="contained"
//           color="success"
//           onClick={() => handleSubmit("accepted")}
//           style={{ marginRight: "10px" }}
//           disabled={isLoading}
//         >
//           Accept
//         </Button>
//         {/* <Button
//           variant="outlined"
//           color="error"
//           onClick={() => handleSubmit("rejected")}
//           disabled={isLoading}
//         >
//           Reject
//         </Button> */}
//       </div>

//       <Dialog open={openAlert} onClose={handleCloseAlert}>
//         <DialogTitle>Missing Required Field</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Please enter a all the fields.</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseAlert} autoFocus>
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

// export default AlertDialogForm;



  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
       {/* dev */}
       {/* {currentEmpId === "EL_0003" ? ( */}
       {/* prd */}
      {currentEmpId === "300321" ? (
     
        <>
          <label htmlFor="drawingRevision" style={{ display: "block", marginBottom: 8 }}>
            Drawing New/Revision No*
          </label>
          <TextField
            id="drawingRevision"
            placeholder="Enter drawing revision"
            fullWidth
            required
            value={drawingValue}
            onChange={(e) => setDrawingValue(e.target.value)}
            size="small"
            margin="dense"
          />

          <label htmlFor="ecnEdinNo" style={{ display: "block", marginBottom: 8, marginTop: 12 }}>
            ECN EDIN No*
          </label>
          <TextField
            id="ecnEdinNo"
            placeholder="Enter ECN/EDIN number"
            fullWidth
            required
            value={ednValue}
            onChange={(e) => setEdnValue(e.target.value)}
            size="small"
            margin="dense"
          />
        </>
      ) : (
        <>
          <label htmlFor="implementedDate" style={{ display: "block", marginBottom: 8 }}>
            Implemented Date*
          </label>
          <TextField
            id="implementedDate"
            type="date"
            fullWidth
            required
            value={implementedDate}
            onChange={(e) => setImplementedDate(e.target.value)}
            size="small"
            margin="dense"
            InputLabelProps={{ shrink: true }}
          />

          <label htmlFor="implementedVehicle" style={{ display: "block", marginBottom: 8, marginTop: 12 }}>
            Implemented Vehicle*
          </label>
          <TextField
            id="implementedVehicle"
            placeholder="Enter vehicle (e.g., Model X, VIN, variant)"
            fullWidth
            required
            value={implementedVehicle}
            onChange={(e) => setImplementedVehicle(e.target.value)}
            size="small"
            margin="dense"
          />
          <label htmlFor="comment" style={{ display: "block", marginBottom: 8 }}>
                  Comment*
                </label>
          
                <TextField
                  id="comment"
                  placeholder="Enter comment"
                  fullWidth
                  required
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  size="small"
                />
        </>
      )}

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <Button
          variant="contained"
          color="success"
          onClick={() => handleSubmit("accepted")}
          style={{ marginRight: "10px" }}
          disabled={isLoading}
        >
          Accept
        </Button>

   
        <Button
          variant="outlined"
          color="error"
          onClick={() => handleSubmit("rejected")}
          disabled={isLoading}
        >
          Reject
        </Button>
      
      </div>

      <Dialog open={openAlert} onClose={handleCloseAlert}>
        <DialogTitle>Missing Required Field</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter all the required fields.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialogForm;
